import { z } from "zod";
import type { Enums } from "../../../types";

export const INTEGRATIONS: Array<Enums<"integrationType">> = ["personio", "webfleet"] as const;

export const getIntegrationStateSchema = z.object({
	integrationType: z.enum(INTEGRATIONS),
});

export type GetIntegrationState = z.infer<typeof getIntegrationStateSchema>;
